import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import CategoryView from "./category/reducers";

export default (history) =>
  combineReducers({
    router: connectRouter(history),

    CategoryView,
  });
